import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "suggestButton",
        "errorsAnalyse",
        "resume",
        "launchAnalyse",
        "launchAnalyseMobile",
        "askConfirmation",
        "analyseResult",
        "nameInResume",
        "skillsNumber",
        "skillsCollectionContainer",
        "toggleSkillsButton",
        "skipSkillsInput",
        "formContainer",
    ]

    static values = {
        prototypeSkills: String,
    }

    connect() {
        if (this.hasResumeTarget) {
            this.resumeTarget.addEventListener("change", this.submitResumeFormAjax.bind(this))
        }
    }

    resetComponent() {
        this.launchAnalyseTarget.classList.remove("lg:hidden")
        this.launchAnalyseMobileTarget.classList.remove("hidden")

        this.askConfirmationTarget.classList.add("hidden")
        this.analyseResultTarget.classList.add("hidden")
        this.formContainerTarget.classList.add("hidden")
        this.analyseResultTarget.classList.remove("error")
        this.analyseResultTarget.classList.remove("finished")
    }

    askConfirmation() {
        this.launchAnalyseMobileTarget.classList.add("hidden")
        this.launchAnalyseTarget.classList.add("lg:hidden")
        this.formContainerTarget.classList.remove("hidden")
        this.askConfirmationTarget.classList.remove("hidden")
    }

    removeSkill(event) {
        const skillElement = event.currentTarget
        const container = this.skillsCollectionContainerTarget // Add appropriate class/selector

        // Remove the skill element
        skillElement.remove()

        // Reindex remaining skills
        const remainingSkills = container.children
        Array.from(remainingSkills).forEach((skill, index) => {
            // Update all form field names to have sequential indices
            skill.querySelectorAll("input").forEach((input) => {
                const name = input.getAttribute("name")
                // Replace the old index with the new one
                input.setAttribute("name", name.replace(/\[(\d+)\]/, `[${index}]`))
            })
        })

        this.submitForm()
    }

    toggleSkills() {
        const skipSkillsInput = this.skipSkillsInputTarget
        skipSkillsInput.value = !this.toggleSkillsButtonTarget.checked
        skipSkillsInput.form.submit()
    }

    fillSuggestion(event) {
        const item = document.createElement("div")
        const container = this.skillsCollectionContainerTarget
        item.innerHTML = this.prototypeSkillsValue.replace(/__name__/g, container.children.length)

        const labelElement = item.querySelector("[data-analysed-cv-label]")
        const keyInput = item.querySelector("[data-analysed-cv-key]")
        const textInput = item.querySelector("[data-analysed-cv-text]")

        if (!labelElement || !keyInput || !textInput) {
            return
        }

        labelElement.textContent = event.detail.item.label
        keyInput.value = event.detail.item.key
        textInput.value = event.detail.item.label

        container.appendChild(item.firstChild)
        this.suggestButtonTarget.value = ""
        this.submitForm()
    }

    submitForm() {
        const form = document.getElementById("search-form")
        if (form) form.submit()
    }

    submitResumeFormAjax() {
        const input = this.resumeTarget
        const form = input.closest("form")

        if (!form) return

        this.askConfirmationTarget.classList.add("hidden")
        this.analyseResultTarget.classList.remove("hidden")

        const formData = new FormData(form)

        fetch(form.action, {
            method: form.method || "POST",
            body: formData,
            headers: {
                "X-Requested-With": "XMLHttpRequest",
            },
            signal: AbortSignal.timeout(30000),
        })
            .then(async (response) => {
                if (!response.ok) {
                    const errorJson = await response.json()
                    throw errorJson
                }

                return response.json()
            })
            .then((data) => {
                this.nameInResumeTarget.textContent = typeof data.firstName === "string" ? data.firstName : "Unknown"
                this.skillsNumberTarget.innerHTML = typeof data.successMessage === "string" ? data.successMessage : ""

                this.analyseResultTarget.classList.add("finished")

                // redirect to the result page url is in redirectUrl on data
                if (data.redirectUrl) {
                    setTimeout(() => {
                        // wait for 2 second before redirecting
                        window.location.href = data.redirectUrl
                    }, 2000)
                }
            })
            .catch((error) => {
                this.disconnect()
                input.value = ""
                this.errorsAnalyseTarget.textContent = ""
                const errors = error?.errors || ["Une erreur est survenue"]
                if (Array.isArray(errors)) {
                    errors.forEach((message) => {
                        const span = document.createElement("span")
                        span.textContent = message
                        this.errorsAnalyseTarget.appendChild(span)
                    })
                }
                this.analyseResultTarget.classList.add("error")
            })
    }
}
